"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Popconfirm = exports.IconButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
var _Icon = _interopRequireDefault(require("../Icon"));
var _Button = require("./Button.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * 按鈕組件
 */

const Button = _ref => {
  let {
    variant = "orange",
    size,
    children,
    disabled,
    loading,
    mr,
    onClick,
    full = true,
    textColor
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Button.UiButton, {
    variant: variant,
    block: true,
    size: size,
    onClick: onClick,
    disabled: disabled,
    loading: loading,
    mr: mr,
    full: full ? 1 : 0,
    style: textColor ? {
      color: textColor
    } : {}
  }, children);
};
const IconButton = _ref2 => {
  let {
    variant = "orange",
    size,
    children,
    disabled,
    loading,
    mr,
    onClick,
    full = true,
    iconName = "close",
    icon,
    type = "default",
    textColor
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_Button.UiButton, {
    variant: variant,
    block: true,
    size: size,
    onClick: onClick,
    disabled: disabled,
    loading: loading,
    mr: mr,
    full: full ? 1 : 0,
    style: textColor ? {
      color: textColor
    } : {}
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, icon ? icon : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: iconName,
    type: type
  })), children);
};
exports.IconButton = IconButton;
const Popconfirm = _ref3 => {
  let {
    title = "",
    variant = "orange",
    size,
    children,
    disabled,
    loading,
    full = true,
    mr,
    onConfirm = () => {}
  } = _ref3;
  const [deletePopup, setDeletePopup] = (0, _react.useState)(false);
  const onConfirmHandle = () => {
    setDeletePopup(false);
    onConfirm();
  };
  return /*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
    title: title,
    visible: deletePopup,
    onConfirm: onConfirmHandle,
    onCancel: () => setDeletePopup(false),
    okText: "\u78BA\u5B9A",
    cancelText: "\u53D6\u6D88"
  }, /*#__PURE__*/_react.default.createElement(Button, {
    variant: variant,
    block: true,
    size: size,
    onClick: () => setDeletePopup(true),
    disabled: disabled,
    loading: loading,
    mr: mr,
    full: full
  }, children));
};
exports.Popconfirm = Popconfirm;
var _default = exports.default = Button;
Button.propTypes = {
  variant: _propTypes.default.string,
  size: _propTypes.default.string,
  children: _propTypes.default.node,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  mr: _propTypes.default.number,
  full: _propTypes.default.bool,
  textColor: _propTypes.default.string
};
IconButton.propTypes = {
  variant: _propTypes.default.string,
  size: _propTypes.default.string,
  children: _propTypes.default.node,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  mr: _propTypes.default.number,
  full: _propTypes.default.bool,
  iconName: _propTypes.default.string,
  type: _propTypes.default.string,
  icon: _propTypes.default.node,
  textColor: _propTypes.default.string
};
Popconfirm.propTypes = {
  title: _propTypes.default.string,
  variant: _propTypes.default.string,
  size: _propTypes.default.string,
  children: _propTypes.default.node,
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  full: _propTypes.default.bool,
  visible: _propTypes.default.bool,
  mr: _propTypes.default.number,
  onConfirm: _propTypes.default.func
};